import tagTester from './_tagTester.js';

export default tagTester('Object');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/_hasObjectTag.js
// module id = 462
// module chunks = 8